import { useState } from "react";
import moment from "moment";
import Widget from "./components/Widget";
import TopRegions from "./components/TopRegions";
import TopWards from "./components/TopWards";
import TopDistricts from "./components/TopDistricts";
import Empty from "./components/Empty";
import Branches from "./components/Branches";
import Genders from "./components/Genders";
import TopMakes from "./components/TopMakes";
import TopModels from "./components/TopModels";
import HomeHeader from "./components/HomeHeader";
import { useQuery } from "@tanstack/react-query";
import { handleEntriesTopBranches } from "../../api/entries";

export default function Dashboard() {
  const initials = {
    branch: 0,
    startDate: moment().startOf("month"),
    endDate: moment().endOf("month"),
  };
  const [filters, setFilters] = useState<any>({ ...initials });

  const params = "";

  const { data: branches } = useQuery({
    queryKey: ["branches", params],
    queryFn: () => handleEntriesTopBranches({ params }),
  });

  const clearFilters = () => {
    setFilters({ ...initials });
  };

  return (
    <div className="m-1">
      <HomeHeader
        title={"Dashboard"}
        subtitle={"Summary of all import records."}
        clearFilters={clearFilters}
        setFilters={setFilters}
        filters={filters}
        branches={branches}
      />
      <div className="grid grid-cols-12 gap-x-1 mb-1">
        <Branches filters={filters} />
        <Genders filters={filters} />
        <Widget />
        <Widget />
      </div>

      <div className="grid grid-cols-12 gap-x-1 mb-2">
        <div className="col-span-12 sm:col-span-4 bg-white shadow-sm border">
          <TopRegions filters={filters} />
        </div>
        <div className="col-span-12 sm:col-span-4 bg-white shadow-sm border">
          <TopDistricts filters={filters} />
        </div>
        <div className="col-span-12 sm:col-span-4 bg-white shadow-sm border">
          <TopWards filters={filters} />
        </div>
      </div>

      <div className="grid grid-cols-12 gap-x-1">
        <div className="col-span-12 sm:col-span-4 bg-white shadow-sm border">
          <TopMakes filters={filters} />
        </div>
        <div className="col-span-12 sm:col-span-4 bg-white shadow-sm border">
          <TopModels filters={filters} />
        </div>
        <div className="col-span-12 sm:col-span-4 bg-white shadow-sm border">
          <Empty title="Metrics Goes Here" />
        </div>
      </div>
    </div>
  );
}
